<template>
  <ul class="nav metismenu" id="side-menu">
    <li :class="todayClass">
      <a id="todayLink" v-on:click="$emit('today')">
        <i class="fa fa-calendar"></i>
        <span class="nav-label">Today</span>
      </a>
    </li>
    <li v-if="incompleteBookingsCount > 0">
      <a id="incompleteBookingsLink" v-on:click="$emit('open-incomplete-bookings')">
        <i class="fa fa-exclamation-circle"></i>
        <span class="nav-label">Bookings to complete ({{ incompleteBookingsCount }})</span>
      </a>
    </li>
    <!--
      was `ui-sref` + `ui-sref-active='active'`. A ui-router directive cannot live in a Vue
      template, so each link emits `navigate` and MenuCtrl does the $state.go, and the `active`
      class comes from `activeState` (the current state name) - see isActive().
    -->
    <li :class="{ active: isActive('router-reporting') }">
      <a id="reportingLink" href="/reporting" v-on:click.prevent="$emit('navigate', 'router-reporting')">
        <i class="fa fa-folder"></i>
        <span class="nav-label">Reporting</span>
      </a>
    </li>
    <li :class="{ active: isActive('router-documents') }">
      <a id="documentsLink" href="/documents" v-on:click.prevent="$emit('navigate', 'router-documents')">
        <i class="fa fa-file"></i>
        <span class="nav-label">Documents</span>
      </a>
    </li>
    <!--
      The settings tabs are vue-router routes inside an Angular shell (step 21), so this is the
      one nav entry that has to move both routers - MenuCtrl delegates to the bridge. A plain
      <a href> is not enough: Angular turns it into a $location pushState, ui-router renders the
      shell, and the Vue router never sees the new URL, leaving the tab empty.
    -->
    <li :class="{ active: isActive('router-settings') }">
      <a id="settingsLink" href="/settings/profile" v-on:click.prevent="$emit('navigate', 'router-settings')">
        <i class="fa fa-cog"></i>
        <span class="nav-label">Settings</span>
      </a>
    </li>
    <!--
      Support opens the widget rather than navigating (#664): it is a panel over whatever page the
      user is on, not a route.
    -->
    <li>
      <a id="supportLink" v-on:click="$emit('open-support')">
        <i class="fa fa-comment"></i>
        <span class="nav-label">Support</span>
        <span class="badge badge-danger" v-if="supportUnread">{{ supportUnread }}</span>
      </a>
    </li>
    <li>
      <a id="logoutButtonTop" v-on:click="$emit('logout')">
        <i class="fa fa-sign-out"></i>
        <span class="nav-label">Logout</span>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'MenuComponent',
  props: {
    supportUnread: {
      type: Number,
      default: 0,
    },
    // MenuCtrl.todayClass - 'active' unless you are on the resources page viewing today.
    todayClass: {
      type: String,
      default: '',
    },
    // The `/api/.../incomplete` count the menu shows (was `ng-if` + `{{ }}`).
    incompleteBookingsCount: {
      type: Number,
      default: 0,
    },
    // The current ui-router state name, for the nav links' `active` class.
    activeState: {
      type: String,
      default: '',
    },
  },
  methods: {
    // `ui-sref-active` used `$state.includes(state)`, which for these leaf states is equality.
    // Reading `activeState` here is also what makes the render re-run on a route change.
    isActive(stateName) {
      return this.activeState === stateName
    },
  },
  mounted() {
    // Reproduces Inspinia's `side-navigation` directive, which ran metisMenu on this ul (the menu
    // is flat, so it is the collapse/submenu behaviour rather than anything this app uses). jQuery
    // comes from webpack's ProvidePlugin; metismenu registers itself on it if it is loaded.
    if (typeof $ !== 'undefined' && $.fn && typeof $.fn.metisMenu === 'function') {
      $(this.$el).metisMenu()
    }
  },
}
</script>
